import React, { useRef, useEffect } from "react";
import './style.scss';
import { image } from "../../Assets";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import { gsap } from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Marquee from "react-fast-marquee";


gsap.registerPlugin(ScrollTrigger);

const HeroSection = () => {
  const swiperRef = useRef();

  const animation = () => {
    // Clear any previous transform to avoid stacking
    gsap.set('.slider-2 #elementimg2', { clearProps: 'transform' });

    // SLIDE 1 ANIMATION
    gsap.timeline({ duration: 0.2 })
      .fromTo('.slider-1 .greenbg', { x: '200%' }, { x: '0%', overwrite: 'auto' })
      .fromTo('.slider-1 #factile-letter', { opacity: 0, x: '10%', y: '-2%' }, { opacity: 1, x: '0%', y: '0%', duration: 0.8, overwrite: 'auto' });

    gsap.timeline()
      .fromTo('.hero h2', { x: '-200%' }, { x: '0%', duration: 0.6, delay: 0.2, overwrite: 'auto' })
      .fromTo('.greenbg2', { x: '200%' }, { x: '0%', delay: 0.4, ease: 'bounce.out', duration: 1, overwrite: 'auto' })
      .fromTo('.swiper-pagination', { x: 300 }, { x: 0, ease: 'bounce.out', duration: 1, overwrite: 'auto' });

    // SLIDE 2 ANIMATION
    gsap.timeline()
      .fromTo('.slider-2 .greenbg', { x: '-200%' }, { x: '0%', overwrite: 'auto' })
      .fromTo('.slider-2 .greenbg2', { x: '200%' }, { x: '0%', delay: 0.4, ease: 'bounce.out', duration: 1, overwrite: 'auto' });

    gsap.fromTo('.slider-2 #elementimg2',
      { opacity: 0,x:'-50%', },
      { opacity: 1,x:'-40%', delay: 0.3, ease: 'power2.inOut', duration: 1, overwrite: 'auto' });

    gsap.fromTo('.slider-2 #elementimg1',
      { opacity: 0, x: '-200%' },
      { opacity: 1, x: '0%', delay: 0.7, ease: 'ease.in', duration: 1, overwrite: 'auto' });

    gsap.fromTo('.slider-2 .elgr1',
      { opacity: 0, x: '-200%' },
      { opacity: 1, x: '0%', delay: 0.5, ease: 'ease.in', duration: 1, overwrite: 'auto' });

    gsap.fromTo('.slider-2 .elgr2',
      { opacity: 0, x: '-200%' },
      { opacity: 1, x: '0%', delay: 0.8, ease: 'ease.in', duration: 1, overwrite: 'auto' });

    // SLIDE 3 ANIMATION
    gsap.timeline()
      .fromTo('.slider-3 #element3',
        { opacity: 0, x: '10%', y: '-20%' },
        { opacity: 1, x: '0%', y: '0%', duration: 0.8, delay: 1, overwrite: 'auto' })
      .fromTo('.slider-3 #element4',
        { opacity: 0, x: '10%', y: '-20%' },
        { opacity: 1, x: '0%', y: '0%', duration: 0.8, delay: 0.2, overwrite: 'auto' });
  };

  const marqueeImages = [
    image.logo1,
    image.logo2,
    image.logo3,
    image.logo4,
    image.logo5,
    image.logo6,
  ];

  useEffect(() => {
    animation(); // Initial load animation
  }, []);

  return (
    <div className="tw-relative tw-overflow-hidden">
      <Swiper
        slidesPerView={1}
        centeredSlides={true}
        pagination={{
          el: '.swiper-pagination',
          clickable: true,
          renderBullet: (index, className) =>
            `<span class="${className}">${index + 1}</span>`
        }}
        onSlideChange={() => animation()}
        className="hero-slider-wrapper"
        autoplay={{
          delay: 8000,
          disableOnInteraction: false,
          pauseOnMouseEnter: false
        }}
        modules={[Navigation, Autoplay, Pagination]}
        onBeforeInit={(swiper) => {
          swiperRef.current = swiper;
        }}
      >
        {/* Slide 1 */}
        <SwiperSlide>
          <section className="slider-1 hero">
            <div className="container">
              <div className="row">
                <div className="col-6">
                  <div className="content-wrapper">
                    <h2>Transforming Construction Through Precision and Digital Expertise</h2>
                    <p>Fractile Studio partners with AEC teams to modernize workflows, strengthen coordination, and deliver project outcomes with unmatched accuracy. Our digital solutions empower you to build with confidence—on schedule and at scale.</p>
                    <button className="btn-2-white">See Our Work</button>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </SwiperSlide>   
        {/* Slide 1 */}
        <SwiperSlide>
          <section className="slider-2 hero">
            <div className="container">
              <div className="row">
                <div className="col-6">
                  <div className="content-wrapper">
                    <h2>Transforming Construction Through Precision and Digital Expertise</h2>
                    <p>Fractile Studio partners with AEC teams to modernize workflows, strengthen coordination, and deliver project outcomes with unmatched accuracy. Our digital solutions empower you to build with confidence—on schedule and at scale.</p>
                    <button className="btn-2-white">See Our Work</button>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </SwiperSlide>     
        {/* Slide 1 */}
        <SwiperSlide>
          <section className="slider-3 hero">
            <div className="container">
              <div className="row">
                <div className="col-6">
                  <div className="content-wrapper">
                    <h2>Transforming Construction Through Precision and Digital Expertise</h2>
                    <p>Fractile Studio partners with AEC teams to modernize workflows, strengthen coordination, and deliver project outcomes with unmatched accuracy. Our digital solutions empower you to build with confidence—on schedule and at scale.</p>
                    <button className="btn-2-white">See Our Work</button>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </SwiperSlide>        
        {/* <div className="swiper-pagination"></div> */}
      </Swiper>
      <div className="maquee-container">
        <Marquee>
          <div className="d-flex tw-justify-evenly" style={{gap:'100px'}}>
            {marqueeImages.concat(marqueeImages).map((img, index) => (
              <div key={index}>
                <img src={img} alt={`Marquee ${index}`} />
              </div>
            ))}
          </div>        
        </Marquee>
      </div>
      
      
    </div>
  );
};

export default HeroSection;
